import { FetchTemplatesRequest } from './../../templates/templates.actions'
import { getTemplatesState } from './../../templates/templates.selectors'
import { environment } from './../../../../environments/environment'
import {
  SetDefaultData,
  FetchPropertyTypeTemplateRequest,
  UpdateField,
  UpdatePropertyTypeTemplateRequest,
} from '../property-type-templates.actions'
import { getUpdatePropertyTypeTemplateState } from '../property-type-templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { debounceTime, Subject, Subscription } from 'rxjs'
import { Map } from 'immutable'
import jsonToFormData from 'json-form-data'

@Component({
  selector: 'app-update-property-type-template',
  templateUrl: './update-property-type-template.component.html',
  styleUrls: ['./update-property-type-template.component.css'],
})
export class UpdatePropertyTypeTemplateComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private templatesState$: Subscription
  public isLoading: boolean
  public templateId: number
  public templates: [] = []
  public isPropertyTypesOpen = false
  public onTemplatesAutocomplete$ = new Subject<string>()
  public templatesAutocomplete$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.templateId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateTemplate'))
    this.state$ = this.store
      .pipe(select(getUpdatePropertyTypeTemplateState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        filters: {
          matchAnd: [{ field: 'type', value: 'RDN_TEMPLATE' }],
        },
        pageSize: 20,
        page: 0,
      }),
    )

    this.store.dispatch<any>(
      new FetchPropertyTypeTemplateRequest(this.templateId),
    )

    this.templatesAutocomplete$ = this.onTemplatesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(
            new FetchTemplatesRequest({
              filters: keyword
                ? {
                    or: [{ field: 'name', value: keyword }],
                    matchAnd: [{ field: 'type', value: 'RDN_TEMPLATE' }],
                  }
                : {},
              pageSize: 20,
            }),
          )
        }
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
    this.templatesAutocomplete$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateTemplate.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateTemplate',
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      propertyType: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdatePropertyTypeTemplateRequest(this.templateId, payload),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateTemplate',
        ),
      )
    }
  }
}
